import { render } from "./Produits.vue?vue&type=template&id=3503e368"
import script from "./Produits.vue?vue&type=script&lang=js"
export * from "./Produits.vue?vue&type=script&lang=js"

import exportComponent from "/data/www/cavilam/boutique/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__